import React, { Component } from 'react';
import { UncontrolledCollapse, Input, Badge, Container, ListGroup, ListGroupItem, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import { BuscarMetaBonificacion, BuscarMaterialPromo } from '../../store/sagas/bonificacionApi';
import localStorageCustom from '../../utilitarios/localStorage';
import { notificacion } from '../../utilitarios/util';
import { data } from '../../constants/Constants';
import Spinner from "../reusable/Loader";

export class Bonificaciones extends Component {
  static displayName = Bonificaciones.name;

  constructor(props) {
    super(props);
    this.state = {
      pillActive: 0,
      loading: true,
      dealer: {},
      linea: {},
      asociado: {},
      metasBonificaciones: [],
      dataTab: {},
      detalle: [],
      anioActual: new Date().getFullYear(),
      mesActual: new Date().getMonth() + 1
    };
  }
  checkParams() {

  }
  load = async () => {
    let data = localStorageCustom.prototype.getUsuario();
    this.setState({ loading: true, dealer: data.dealer, linea: data.linea, asociado: data.asociado }, () => {
      this.postBuscarMetaBonificacion(data.dealer, data.linea);
    })
  }
  componentDidMount() {
    window.scrollTo(0, 0)
    this.load();
    this.checkParams();

  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  postBuscarMetaBonificacion = async (dealer, linea) => {

    BuscarMetaBonificacion(dealer.codcliente,
      dealer.correoElectronico, this.state.anioActual, this.state.mesActual, linea.vkorg)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            dataTab: (result.dto.metasBonificaciones.length > 0) ? result.dto.metasBonificaciones[0] : [],
            detalle: (result.dto.metasBonificaciones.length > 0) ? result.dto.metasBonificaciones[0].detalle : [],
            metasBonificaciones: result.dto.metasBonificaciones
            //titulo: result.dto.sistemaRepuestos[0].sistema,
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Metas y Bonificaciones", error.message ?? null);
        });
      });
  }

  render() {
    const { pillActive, loading, metasBonificaciones, dataTab, detalle } = this.state;

    return (
      <div>
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Metas y Bonificaciones</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard' className="active">Dashboard</Link></li>
              <li>Metas y Bonificaciones</li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <h6 className="title white mobile px-5">
            <a onClick={() => this.props.history.goBack()} className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></a>
            Metas y Bonificaciones
          </h6>
          <div className="tab-pills">
            {metasBonificaciones.map((data, index) => {
              return (
                <button
                  key={index}
                  className={`pill${(pillActive == index) ? " active" : ""}`}
                  type="button"
                  disabled={metasBonificaciones.length == 1}
                  onClick={() => this.switchPill(index)}
                >
                  Repuestos {data.linea}
                </button>
              )
            })}
          </div>
          <div className="card">
            <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
            <div className="estado-cuenta-date">
              <div className="content-left">
                <h5 className='paragraph-1 bold'>{dataTab.tituloMeta}</h5>
                <h1 className='title-2 bold mt-2' style={{ color: c.verdeClaro }}>{dataTab.sMontoM}</h1>
              </div>
              <div className="content-right">
                <span className='paragraph-2 light' style={{ color: c.azulClaro }}>{dataTab.sMontoR}</span>
                <span className='paragraph-2 light' style={{ color: c.azulClaro }}>{dataTab.sPorCum}</span>
                <button className="btn-icon rounded"
                  type="button"
                  onClick={() => this.setGraficoBarras(dataTab, detalle)}
                >
                  <SvgAssets icon="icon-chart" fill={c.naranja} />
                </button>
              </div>
            </div>
            <ListGroup flush className="container_840">
              <ListGroupItem>
                <Row form>
                  <Col xs={2}></Col>
                  <Col xs={3}>
                    <span className='paragraph-3' style={{ color: c.grisMedio }}>Meta</span>
                  </Col>
                  <Col xs={3}>
                    <span className='paragraph-3' style={{ color: c.grisMedio }}>Obtenidas</span>
                  </Col>
                  <Col xs={2}>
                    <span className='paragraph-3' style={{ color: c.grisMedio }}>% de Cump.</span>
                  </Col>
                  <Col xs={1}></Col>
                  <Col xs={1}></Col>
                </Row>
              </ListGroupItem>
              {detalle.map((data, i) => {
                return (
                  <ListGroupItem key={i + 1}>
                    <Row form>
                      <Col xs={2} md={2}>
                        <span className='paragraph-3 desktop_parrafo2 bold' style={{ color: c.azulClaro }}>{data.nomMes}.</span>
                      </Col>
                      <Col xs={3} md={3}>
                        <span className='paragraph-3 desktop_parrafo2 light' style={{ color: c.azulClaro }}>{data.sMontoM}</span>
                      </Col>
                      <Col xs={3} md={3}>
                        <span className='paragraph-3 desktop_parrafo2 light' style={{ color: c.azulClaro }}>{data.sMontoR}</span>
                      </Col>
                      <Col xs={2} md={2}>
                        <span className='paragraph-3 bold desktop_parrafo2' style={{ color: c.azulClaro }}>{data.sPorCum}</span>
                      </Col>
                      <Col xs={1} md={1}>
                        <span className="badge" style={{ backgroundColor: (data.porCum >= 100) ? c.verdeClaro : c.rojoClaro }} />
                      </Col>
                      <Col xs={1} md={1}>
                        {/* {
                          (data.porCum >= 100) ?
                            <button className="btn-icon"
                              type="button"
                              onClick={() => this.setBonificacion(data, dataTab)}
                            >
                              <SvgAssets icon="icon-right" fill={c.verdeClaro} />
                            </button>
                            : null
                        } */}
                        <button className="btn-icon"
                          type="button"
                          onClick={() => this.setBonificacion(data, dataTab)}
                        >
                          <SvgAssets icon="icon-right" fill={c[(data.porCum >= 100) ? "verde" : "rojo"]} />
                        </button>
                      </Col>
                    </Row>
                  </ListGroupItem>
                )
              })}
            </ListGroup>
          </div>
        </Container>
      </div>
    );
  }

  switchPill = (index) => {
    this.setState({ loading: true });
    let _metasBonificaciones = this.state.metasBonificaciones;

    this.setState({ pillActive: index, dataTab: _metasBonificaciones[index], detalle: _metasBonificaciones[index].detalle, loading: false })

    // if (this.state.pillActive == 0) {
    //   this.setState({ pillActive: 1, dataTab: _metasBonificaciones[1], detalle: _metasBonificaciones[1].detalle, loading: false })
    // } else {
    //   this.setState({ pillActive: 0, dataTab: _metasBonificaciones[0], detalle: _metasBonificaciones[0].detalle, loading: false })
    // }

  }
  setBonificacion(item, dataTab) {
    this.setState({ loading: true });
    BuscarMaterialPromo(this.state.dealer.codcliente, this.state.dealer.correoElectronico, this.state.anioActual,
      this.state.mesActual, this.state.linea.vkorg, item.linea)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false });
          this.props.history.push({
            pathname: 'Bonificacion',
            state: {
              materialPromo: result.dto.materialPromo,
              detalle: item, dataTab: dataTab
            }
          });
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Metas y Bonificaciones", error.message ?? null);
        });
      });
  }

  setGraficoBarras(dataTab, detalle) {
    this.props.history.push({
      pathname: '/bonificacion-grafico',
      state: {
        detalle: detalle, dataTab: dataTab
      }
    })
    // this.props.navigation.navigate('BonificacionGrafico', { detalle: detalle, dataTab: dataTab });

  }
}
